// extracted by mini-css-extract-plugin
export default {"title":"CompanyProfilePage_title__WOCZe","formsContainer":"CompanyProfilePage_formsContainer__4ot+M","form":"CompanyProfilePage_form__7xNcR"};